/**
 * Parse club.instagram from API (handle, @handle, or instagram.com URL) for display and linking.
 * Keep in sync with mobile/src/utils/instagramUtils.js
 */

const RESERVED_PATH_SEGMENTS = new Set([
  'p',
  'reel',
  'reels',
  'stories',
  'explore',
  'accounts',
  'direct',
  'tv',
]);

function normalizeHandleSegment(segment) {
  if (typeof segment !== 'string') return null;
  const h = segment.replace(/^@/, '').trim();
  if (!h || h.length > 30 || !/^[a-zA-Z0-9._]+$/.test(h)) {
    return null;
  }
  return h;
}

function handleOnly(trimmed) {
  let h = trimmed.replace(/^@/, '').trim();
  if (h.includes('/')) {
    const parts = h.split('/').filter(Boolean);
    h = parts[parts.length - 1] || '';
  }
  const normalized = normalizeHandleSegment(h);
  if (!normalized) return null;
  return {
    handle: normalized,
    profileUrl: `https://www.instagram.com/${encodeURIComponent(normalized)}/`,
  };
}

/**
 * @param {unknown} raw - Value from club.instagram
 * @returns {{ handle: string, profileUrl: string } | null}
 */
export function parseInstagramProfile(raw) {
  if (typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;

  let urlStr = trimmed;
  if (!/^https?:\/\//i.test(urlStr)) {
    if (/^(?:www\.)?instagram\.com\/?/i.test(urlStr)) {
      urlStr = urlStr.match(/^www\./i) ? `https://${urlStr}` : `https://${urlStr}`;
    }
  }

  if (/^https?:\/\//i.test(urlStr)) {
    try {
      const u = new URL(urlStr);
      const host = u.hostname.replace(/^www\./i, '').toLowerCase();
      if (host !== 'instagram.com') {
        return null;
      }
      const parts = u.pathname.split('/').filter(Boolean);
      if (parts.length === 0) {
        return null;
      }
      const first = parts[0];
      if (RESERVED_PATH_SEGMENTS.has(first.toLowerCase())) {
        return null;
      }
      const normalized = normalizeHandleSegment(first);
      if (!normalized) return null;
      return {
        handle: normalized,
        profileUrl: `https://www.instagram.com/${encodeURIComponent(normalized)}/`,
      };
    } catch {
      return handleOnly(trimmed);
    }
  }

  return handleOnly(trimmed);
}
